import React from 'react';

import { TextField } from '@mui/material';

import Styles from '../../lib/Styles';
import classes from './DisplayBoxedField.module.scss';

export default function DisplayReadOnlyField(props: any) {
  const { label, value, required } = props;
  const cx = new Styles(classes).cx;

  return (
    <div className={cx('root')} >
    <TextField
      disabled={true}
      label={label}
      defaultValue={undefined}
      inputProps={{
        readOnly: true
      }}
      variant="outlined"
      value={value}
      required={required}
    />
    </div>
  );
}
